import Vue from "vue";
import store from "@/store";
import VueRouter from "vue-router";

// Routes
import { canNavigate } from "@/libs/acl/routeProtection";
import {
  isUserLoggedIn,
  getUserData,
  getUserModules,
  getUserSections,
  getUserSectionsLocalStorage,
  getHomeRouteForLoggedInUser,
  getHomeRouteForLoggedInUserLocalStorage
} from "@/auth/utils";

/* Routes for Soft Transport Zerg */
import menu from "@/router/routes/zerg-factory/home.route";
import rrhh from "@/views/rrhh/router/index.js";
// import apps from "./routes/apps";
// import dashboard from "./routes/dashboard";
// import uiElements from "./routes/ui-elements/index";
import pages from "./routes/pages";
import MonitoringRoute from "@/views/monitoring/router/index";
import UsersRoute from "@/views/users/router/index";
import SettingsRoute from "@/views/settings/router/index";
import DriverRoute from "@/views/driver/router/index.js";
import AttenanceRouter from "@/views/attendance/router/index.js";
import TreasuryRouter from "@/views/treasury/router/index.js"
import BookeepingRouter from "@/views/bookeeping/router/index.js";
import WorkshopRouter from "@/views/workshop/router/index.js"
import OperationsRouter from "@/views/operations/router/index.js";

import apps from "./routes/apps";
// import dashboard from "./routes/dashboard";
import uiElements from "./routes/ui-elements/index";
import chartsMaps from "./routes/charts-maps";
// import formsTable from "./routes/forms-tables";
import others from "./routes/others";

Vue.use(VueRouter);
Vue.use(store);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    { path: "/", redirect: { name: "zerg-menu" } },
    ...menu,
    ...rrhh,
    ...pages,
    ...SettingsRoute,
    ...MonitoringRoute,
    ...DriverRoute,
    ...UsersRoute,
    ...uiElements,
    ...AttenanceRouter,
    ...TreasuryRouter,
    ...BookeepingRouter,
    ...WorkshopRouter,
    ...OperationsRouter,
    // ...apps,
    // ...dashboard,
    // ...dashboard,
    ...chartsMaps,
    // ...formsTable,
    // ...others,
    {
      path: "*",
      redirect: "error-404",
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  const isLoggedIn = isUserLoggedIn();
  const userData = getUserData();
  // const userModules = await getUserModules();
  // const userSections = await getUserSections();
  const userSections = getUserSectionsLocalStorage();
  const nextModule = to.matched[0]?.meta?.module;
  const child = to.matched[to.matched.length - 1];

  const loginRoute = "auth-login";
  const unAuthorizedRoute = "misc-not-authorized";
  const moduleIsUndefined = nextModule == undefined;
  const fromIsDifferentTo = from.matched[0]?.meta?.module != nextModule;

  router.onReady(() => {
    if (!moduleIsUndefined && fromIsDifferentTo) {
      if (userData) {
        store.dispatch("auth/updateCurrentUserModuleRole", nextModule);
      }
      store.commit("SidebarStore/SET_NAVIGATION_ITEMS_BY_MODULE", {
        module: nextModule,
      });
    }
  });

  if (isLoggedIn) {
    // userModules
    if (!canNavigate(to, userSections, child)) {
      // Redirect to login if not logged in
      if (!isLoggedIn) return next({ name: loginRoute });
      // If logged in => not authorized
      if (to.name !== unAuthorizedRoute) {
        if (to.redirectedFrom) {
          try {
            let sectionsArray = [];
            if (Array.isArray(userData.arr_sections)) {
              sectionsArray = userData.arr_sections;
            } else if (typeof userData.arr_sections === 'string') {
              sectionsArray = JSON.parse(userData.arr_sections);
            }
            
            if (sectionsArray && sectionsArray.length > 0) {
              const firstAccessibleSection = sectionsArray.find(
                (sec) => sec.module_id == nextModule && userSections.includes(sec.section_id)
              );
              if (firstAccessibleSection && firstAccessibleSection.route) {
                const isAlreadyTargetRoute = to.matched.some(r => r.name === firstAccessibleSection.route);
                if (!isAlreadyTargetRoute) {
                  return next({ name: firstAccessibleSection.route });
                }
              }
            }
          } catch (e) {
            console.error("Error evaluating default dynamic section", e);
          }
        }
        return next({ name: unAuthorizedRoute });
      }
    }
  } else if (to.name !== loginRoute) {
    return next({ name: loginRoute });
  }
  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    next(getHomeRouteForLoggedInUserLocalStorage(userData ? userData.role_id : null));
  }
  return next();
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
